<template>
    <div class="page container" data-page="tests">
        
        <!--File Uploader-->
        <template v-if="$store.state.currentUser !== null">
            <FileUpload
                :key="`file_uploader_${fileUploaderKey}`"
                ref="fileUpload"
                :path="'files/'"
                :hide="true"
                :uid="$store.state.currentUser.uid"
                @upload-success="syncAllUploadedFiles"
                @delete-success="removedFile"
            ></FileUpload>
        </template>
        <a 
            href="#0"
            @click.prevent="$refs.fileUploadInput.click()"
            class="btn secondary icon-only mb-4"
        >
            <ion-icon name="cloud-upload"></ion-icon>
        </a>
        <input type="file" ref="fileUploadInput" multiple="multiple" class="fileUploadInput hidden" @change="customInputFilesHandler" v-show="false" />

        <Files
            @delete-file="(file) => $refs.fileUpload.deleteFiles(file)"
        ></Files>

    </div>
</template>

<script>
import FileUpload from '@/components/uploader/FileUpload'
import Files from '@/components/user/Files'
import axios from 'axios'

export default {
    name: 'Tests',

    components: {
        FileUpload,
        Files
    },

    data(){
        return{
            fileUploaderKey: 0,
        }
    },

    mounted(){
        // this.getUserGeoLocation()
        // this.sendSMS()
    },

    methods: {
        // File Uploader
        syncAllUploadedFiles(files){

            console.log('Finished uploading and generating all files: ', files)
 
            for(let i = 0; i < files.length; i++){
                this.files.push(files[i])
            }

            this.fileUploaderKey += 1
        },
        removedFile(fileId){
            let newFiles = this.files.filter(file => {
                return file.id !== fileId
            })
            this.files = newFiles
        },
        async getAllFiles(){

            let allFiles = await this.$refs.fileUpload.listFiles()

            console.log('Messages :: Get all files: ', allFiles)

            // this.files = allFiles
        },
        customInputFilesHandler(e){
            let droppedFiles = e.target.files
            if(!droppedFiles) return
            this.$refs.fileUpload.addFilesToPond(droppedFiles)
        },

        // Geo Location
        getUserGeoLocation(){
            let userProfile = this.$store.state.userProfile
            let userId = this.$store.state.currentUser.uid

            console.log('Start getting user geo location for: ', userProfile)
            
            if(userProfile.ipaddress !== null){
                console.log('User has ip address: ', userProfile.ipaddress)

                let options = {
                    ipaddress: userProfile.ipaddress
                }

                this.$http.post(`https://us-central1-vanmgl.cloudfunctions.net/ipToGeo`, options).then(res => {

                    console.log('Received user geo location: ', res)

                    if(res.statuss === 200){
                        if(res.body){
                            if(typeof res.body.data !== 'undefined'){
                                let userGeoLocation = res.body.data
                            }
                        }
                    }

                }).catch(err => {
                    console.log('Error getting geo location for user: ', err)
                })
            }
        },

        // Emails
        sendEmail(){
            // const gmail = require('gmail-send')

            const send = gmail({
                user: 'info@onemgl.com',
                pass: 'Npgadmin4210!!',
                to: 'anand10ro@yahoo.com',
                subject: 'Test email 1',
                html: '<h3>Test Email 1</h3><br><p>This is a sample email with HTML content.</p>'
            }, (err, res, full) => {
                if(err){
                    console.log('Error sending email: ', err)
                    return
                }

                if(res){
                    console.log('Successfully sent email: ', res)
                }
            })
        },

        // SMS
        sendSMS(){

            const options = {
                method: 'POST',
                url: 'https://d7sms.p.rapidapi.com/secure/send',
                headers: {
                    'content-type': 'application/json',
                    authorization: 'Basic aW5mb0BvbmVtZ2wuY29tOk5wZ2FkbWluNDIxMCEh',
                    'x-rapidapi-key': 'be0c8d1fabmsh6f011ce9fb0ca75p158ba7jsn4dc4e8f4859c',
                    'x-rapidapi-host': 'd7sms.p.rapidapi.com'
                },
                data: {
                    content: 'Test Message',
                    from: 'OneMgl',
                    to: 16049998016
                }
            }

            axios.request(options).then(res => {
                console.log('Successfully sent sms: ', res)
            }).catch(err => {
                console.error('Error sending sms: ', err)
            })

        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/Tests/Tests.vue